import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useAppSelector } from '../../hooks/redux';
import { CustomMUIButton } from '../../components/commons/buttons/CustomMUIButton';
import { AnimatedIcon } from '../../components/commons/AnimatedIcon';
import ErrorIconLight from '../../assets/images/lottieIcons/error/error.light.json';
import ErrorIconDark from '../../assets/images/lottieIcons/error/error.dark.json';
import { ButtonClassNames, GlobalRouteNames } from '../../models/Common';

export const SurveyUnavailable = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { isAuth } = useAppSelector((state) => state.authReducer);

  const handleButton = () => {
    const path = isAuth ? GlobalRouteNames.HomePage : GlobalRouteNames.LoginPage;
    history.push(path);
  };

  return (
    <div className="user-survey-error page">
      <div className="user-survey-error__container container">
        <AnimatedIcon lightIcon={ErrorIconLight} darkIcon={ErrorIconDark} className="page-404__icon-limit" />
        <div className="user-survey-error__content">
          <h1>{t('qualityAssessment.linkExpired')}</h1>
          <div className="user-survey-error__content__text-btn-container">
            <CustomMUIButton
              label={t('qualityAssessment.toMain')}
              handleClick={handleButton}
              className={ButtonClassNames.PrimaryFulfilled}
              isBold
            />
          </div>
        </div>
      </div>
    </div>
  );
};
